import { createRouter, createWebHistory } from 'vue-router'
import { useSessaoStore } from '@/stores/sessao'
import { PapelUsuario } from '@/types/enums'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/aceitar-convite',
      name: 'AceitarConvite',
      component: () => import('@/pages/AceitarConvite.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/convites/aceitar',
      redirect: to => {
        return { name: 'AceitarConvite', query: to.query }
      }
    },
    {
      path: '/redefinir-senha',
      name: 'RedefinirSenha',
      component: () => import('@/pages/RedefinirSenha.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/contato',
      name: 'Contato',
      component: () => import('@/pages/Contato.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/manutencao',
      name: 'Manutencao',
      component: () => import('@/pages/Manutencao.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/HomeProjetos.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:id',
      name: 'ProjetoDetalhe',
      component: () => import('@/pages/ProjetoDetalhe.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: () => import('@/pages/Perfil.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/dashboard',
      name: 'AdminDashboard',
      component: () => import('@/pages/admin/DashboardPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/dashboard/uso',
      name: 'AdminUsoPortal',
      component: () => import('@/pages/admin/UsoPortalPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/clientes',
      name: 'AdminClientes',
      component: () => import('@/pages/admin/ClientesPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/projetos',
      name: 'AdminProjetos',
      component: () => import('@/pages/admin/ProjetosPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/convites',
      name: 'AdminConvites',
      component: () => import('@/pages/admin/ConvitesPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/cargos',
      name: 'AdminCargos',
      component: () => import('@/pages/admin/CargosPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/auditoria',
      name: 'AdminAuditoria',
      component: () => import('@/pages/admin/AuditoriaPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, requiresAdminOnly: true }
    },
    {
      path: '/admin/usuarios',
      name: 'AdminUsuarios',
      component: () => import('@/pages/admin/UsuariosPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin',
      redirect: '/admin/clientes'
    },
    {
      path: '/viewer/:url',
      name: 'ViewerPdf',
      component: () => import('@/pages/ViewerPdf.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/monitor',
      name: 'AdminMonitor',
      component: () => import('@/pages/admin/MonitorPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/pages/NotFound.vue'),
      meta: { requiresAuth: false }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const sessaoStore = useSessaoStore()
  
  if (to.meta.requiresAuth) {
    if (!sessaoStore.estaAutenticado) {
      const sessaoValida = await sessaoStore.verificarSessao()
      if (!sessaoValida) {
        next('/login')
        return
      }
    }

    if (to.meta.requiresAdmin) {
      const papel = sessaoStore.usuario?.papel
      
      if (to.meta.requiresAdminOnly && papel !== PapelUsuario.ADMIN) {
        next('/')
        return
      }
      
      if (papel !== PapelUsuario.ADMIN && papel !== PapelUsuario.VISUALIZADOR) {
        next('/')
        return
      }
    }

    next()
  } else if (!to.meta.requiresAuth && sessaoStore.estaAutenticado && to.name === 'Login') {
    next('/')
  } else {
    next()
  }
})

export default router
